import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation transferKit($id: String!, $data: transferKitInput!) {
    transferKit(id: $id, data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const transferKitRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.TransferKitInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'kit/transfer_kit',
  async (
  params: {id: String;data: TYPES.TransferKitInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.transferKit;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const transferKitSlice = createSlice({
  name: 'transfer_kit',
  initialState: initialState,
  reducers: {
    transferKitClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(transferKitRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(transferKitRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(transferKitRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { transferKitClear } = transferKitSlice.actions;

export const transferKit = createSelector(
  (state: RootState) => state.kit.transferKit.result,
  (state: RootState) => state.kit.transferKit.error,
  (state: RootState) => state.kit.transferKit.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default transferKitSlice.reducer;